import React, { useContext } from 'react';

export type IFrameContextValue = boolean;

const Context = React.createContext<IFrameContextValue>(false);

function IFrameProvider({
  children,
  isIFrame = false
}: React.PropsWithChildren<{ isIFrame?: boolean }>) {
  return <Context.Provider value={isIFrame}>{children}</Context.Provider>;
}

function useIFrameContext() {
  return useContext(Context);
}

export { useIFrameContext, IFrameProvider };
